// extracted by mini-css-extract-plugin
export default {"leave":"ix8Ag","leaveActive":"_5Aac8"};